import * as React from "react";
import axios from "axios";
import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export default function CostAnalysisChart() {
  const [chartData, setChartData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
 const restaurantId = sessionStorage?.getItem("store_id") || "Null";
  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `/server/dashboard-functions/cost-analysis/${restaurantId}`
        );

        if (res.data.success) {
          const data = res.data.data;

          // Transform API data into array of objects for recharts
          const formatted = data.labels.map((label, i) => ({
            date: label,
            standard: data.totalStandardCost[i] || 0,
            actual: data.actualCost[i] || 0,
            wastage: data.wastageAmount[i] || 0,
          }));

          setChartData(formatted);
        } else {
          console.error("API error:", res.data.error || "Unknown error");
        }
      } catch (err) {
        console.error("Error fetching cost analysis data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
const Loader = () => (
    <div className="flex justify-center items-center h-full min-h-[300px]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-[#E57320]  border-solid"></div>
    </div>
);

  return (
    <>
      <div className="mb-4">
        <p className="text-2xl text-gray-800">Cost Component Analysis</p>
      </div>

      {loading ? (
       <Loader/>
      ) : chartData.length > 0 ? (
        <ResponsiveContainer width="100%" height={400}>
          <ComposedChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" 
            
              angle={-45} // Rotate labels if they overlap
              textAnchor="end" // Anchor rotation to the end
              interval="preserveStartEnd" // Helps with tick spacing
              tick={{ fontSize: 12 }} // Smaller font for X-axis ticks
              label={{ value: "Date", position: "insideBottom", offset: 15, fontSize: 14, fill: "#555" }} />
            <YAxis
              yAxisId="left"
              label={{ value: "Cost Amount ($)", angle: -90, position: "insideLeft" }}
              
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              label={{ value: "Wastage ($)", angle: 90, position: "insideRight" }}
            />
            <Tooltip />
           <Legend wrapperStyle={{ paddingTop: "29px" }} /> 

            {/* Bars for costs */}
            <Bar yAxisId="left" dataKey="standard" name="Total Standard Cost" fill="#9369A9" barSize={30} />
            <Bar yAxisId="left" dataKey="actual" name="Actual Cost" fill="#ff7043" barSize={30} />

            {/* Line for wastage */}
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="wastage"
              name="Wastage Amount"
              stroke="#ef5350"
              strokeWidth={3}
              dot={{ r: 5, fill: "#ef5350" }}
            />
          </ComposedChart>
        </ResponsiveContainer>
      ) : (
        <div className="h-[400px] flex items-center justify-center text-gray-500">
          No cost data available to display.
        </div>
      )}
    </>
  );
}

// import * as React from "react";
// import axios from "axios";
// import {
//   ResponsiveContainer,
//   ComposedChart,
//   Bar,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
// } from "recharts";

// export default function CostAnalysisChart() {
//   const [chartData, setChartData] = React.useState([]);

//   React.useEffect(() => {
//     axios
//       .get("http://localhost:3000/server/dashboard-functions/cost-analysis/K071002")
//       .then((res) => {
//         if (res.data.success) {
//           const { labels, totalStandardCost, actualCost, wastageAmount } = res.data.data;

//           const formatted = labels.map((label, i) => ({
//             date: new Date(label).toLocaleDateString("en-US", {
//               month: "short",
//               day: "2-digit",
//             }),
//             standard: totalStandardCost[i],
//             actual: actualCost[i],
//             wastage: wastageAmount[i],
//           }));

//           setChartData(formatted);
//         }
//       })
//       .catch((err) => console.error("Error fetching chart data:", err));
//   }, []);

//   return (
//     <div className="w-full max-w-5xl mx-auto p-4">
//       <h2 className="text-2xl text-gray-800 mb-4">Cost Analysis with Wastage Impact</h2>

//       <ResponsiveContainer width="100%" height={400}>
//         <ComposedChart data={chartData} margin={{ top: 20, right: 30, bottom: 20, left: 20 }}>
//           <CartesianGrid strokeDasharray="3 3" />
//           <XAxis dataKey="date" />
//           <YAxis
//             label={{
//               value: "Cost ($)",
//               angle: -90,
//               position: "insideLeft",
//               style: { textAnchor: "middle" },
//             }}
//           />
//           <Tooltip />
//           <Legend />

//           {/* Bars */}
//           <Bar dataKey="standard" fill="#42a5f5" name="Standard Cost" barSize={30} />
//           <Bar dataKey="actual" fill="#ff7043" name="Actual Cost" barSize={30} />

//           {/* Line for wastage */}
//           <Line
//             type="monotone"
//             dataKey="wastage"
//             stroke="#ef5350"
//             strokeWidth={3}
//             dot={{ r: 5, fill: "#ef5350" }}
//             name="Wastage"
//           />
//         </ComposedChart>
//       </ResponsiveContainer>
//     </div>
//   );
// }
